/* eslint-disable @typescript-eslint/naming-convention */
import {
    FREE_RESERVATION_CART_TYPE,
    FREE_RESERVATION_PAYMENT_INFO,
    DO_MERCHANT_ID,
} from "@payment-client/constants/DineoutDirectPlaceOrder";
import { IDineoutCreateOrderRequest } from "@payment-client/interfaces/Order";

export const getCreateOrderParams = (userId: string, cartType?: string): IDineoutCreateOrderRequest => {
    return {
        cartType: cartType || FREE_RESERVATION_CART_TYPE,
        merchant_id: DO_MERCHANT_ID,
        payment_info: {
            customer_id: userId,
            metadata: "{}",
            order_context: FREE_RESERVATION_PAYMENT_INFO.ORDER_CONTEXT_KEY,
            payment_method: "",
            payment_type: FREE_RESERVATION_PAYMENT_INFO.PAYMENT_TYPE,
            transaction_amount: 0,
        },
    };
};
